var isObject = require('./$.is-object')
  , document = require('./$.global').document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/$.dom-create.js
// module id = 1075
// module chunks = 0